import * as React from "react";

import { useConfirmEmailChangeMutation } from "@/api/email-change";
import { useAuthenticatedUser } from "@/hooks/use-authenticated-user";
import { EmailChangeActionView } from "@/views/auth/email-change/EmailChangeActionView";

export const ConfirmEmailChangeView = () => {
  const [confirmEmailChange] = useConfirmEmailChangeMutation();
  const authenticatedUser = useAuthenticatedUser();
  const submit = React.useCallback(
    (payload: { token: string }) => confirmEmailChange(payload).unwrap(),
    [confirmEmailChange],
  );

  return <EmailChangeActionView action="confirm" submit={submit} isAuthenticated={authenticatedUser.isAuthenticated} />;
};
